// t9hHX 新注册账号提醒(pen frame t9hHX)
import { Link } from 'react-router-dom'

type Props = {
  usernameConfirmedAt: string | null
  emailVerifiedAt: string | null
  phoneReal: string | null
  passwordChangedAt: string | null
  /** 当前账号是否已在本机 saved-accounts 存有密码("保存"即视为已处理) */
  passwordSavedLocally: boolean
}

export function AccountWarningBox(p: Props) {
  const items = [
    {
      key: 'username',
      show: p.usernameConfirmedAt === null,
      text: '用户名未修改',
      to: '/profile/edit',
    },
    {
      key: 'email',
      show: p.emailVerifiedAt === null,
      text: '邮箱未验证',
      to: '/profile/email-bind',
    },
    {
      key: 'phone',
      show: p.phoneReal === null,
      text: '手机号未填写',
      to: '/profile/edit',
    },
    {
      key: 'password',
      show: p.passwordChangedAt === null && !p.passwordSavedLocally,
      text: '密码未修改/保存',
      to: '/profile/change-password',
    },
  ].filter((i) => i.show)

  if (items.length === 0) return null

  return (
    <div
      data-testid="t9hHX"
      className="flex flex-col gap-2.5 rounded-xl border border-[#FFD9D6] bg-[#FFF1F0] p-3.5"
    >
      {/* 头行 */}
      <div className="flex items-center gap-2">
        {/* triangle-alert icon */}
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#FF6B6B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <span className="text-[15px] font-bold text-[#D64545]">请完善账户信息</span>
      </div>

      {/* 条目列表 */}
      {items.map((item, idx) => (
        <div key={item.key} className="flex items-center gap-2">
          <span className="text-[13px] font-bold text-[#FF6B6B]">{idx + 1}.</span>
          <span className="flex-1 text-[13px] text-[#6B7280]">{item.text}</span>
          <Link
            to={item.to}
            data-testid={`t9hHX-fix-${item.key}`}
            className="flex items-center gap-0.5 rounded-xl bg-[#FF6B6B] px-2.5 py-[5px] text-[12px] font-semibold text-white"
          >
            去处理
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M9 6l6 6-6 6" />
            </svg>
          </Link>
        </div>
      ))}
    </div>
  )
}
